var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Classes = OCS.Advisories.Classes || {};
OCS.Advisories.Functions = OCS.Advisories.Functions || {};
OCS.Advisories.Functions.define_AdvisoryDataZone_class = function (in_implements) {
    var implements = [Options, Events];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        class_name: "AdvisoryDataZone",
        data_type: 'AdvisoryDataZone',
        options: {
            issued_time: 0,
            beginning_time: 0,
            ending_time: 0,
            etn: "0000",
            file: '',
            nwso: '',
            phenom: '',
            significance: '',
            zone_id: ""
        },
        adv_events: {},
        initialize: function (op) {
            this.setOptions(op);
        },
        event_action: function (event_ops) {
            var time = parseInt(event_ops.issued_time);
            var act = event_ops.action.toLowerCase();

            var event_options = {
                action: event_ops.action,
                beginning_time: event_ops.beginning_time,
                ending_time: event_ops.ending_time,
                file: event_ops.file,
                issued_time: event_ops.issued_time
            };

            if(act === "can" || act === "exp" || act === "upg") {
                // Adjusting the cancellation to be at the time the cancel product is issued.
                this.set_ending_time(time);
                event_options.ending_time = time;
            } else if(event_ops.ending_time !== this.options.ending_time) {
                this.set_ending_time(event_ops.ending_time);
            }
            this.adv_events[time] = new OCS.Advisories.Classes.AdvisoryDataEventZone(event_options);
        },
        set_ending_time: function(time) {
            this.options.ending_time = parseInt(time);
        },
        get_ending_time: function (time) {
            return this.get_property_at_time(time, 'ending_time');
        },
        get_file: function(time) {
            return this.get_properties_at_time(time, 'file');
        },
        get_feature: function(time) {
            return {type: "Feature", geometry: {}, properties: this.get_properties_at_time(time)};
        },
        get_property_at_time: function(time, property) {
            var event = this.get_adv_event_at_time(time);
            if (event && !event.options[property] && time > 0) {
                return this.get_property_at_time(OCS.Advisories.Functions.get_previous_event_timestamp(this.adv_events, time), property);
            }
            if (event && event.options[property]) {
                return event.options[property];
            }
            return false;
        },
        get_properties_at_time: function(time) {
            var event = this.get_adv_event_at_time(time);
            if (event && !event.options && time > 0) {
                return this.get_properties_at_time(OCS.Advisories.Functions.get_previous_event_timestamp(this.adv_events, time));
            }
            if (event && event.options) {
                return OCS.Utilities.combine_objects(this.options, event.get_properties());
            }
        },
        get_adv_event_at_time: function (time) {
            var found_event = false;
            if (!time) {
                time = this.event_last_update;
            }
            var timestamp = OCS.Advisories.Functions.get_nearest_time(this.adv_events, time);
            if (timestamp) {
                if (this.adv_events.hasOwnProperty(timestamp)) {
                    return this.adv_events[timestamp];
                }
            }
            return found_event;
        },
        destroy: function() {
            this.removeEvents();
            this.options = {};
            this.adv_events = {};
        }
    });
};
OCS.Advisories.Classes.AdvisoryDataZone = OCS.Advisories.Functions.define_AdvisoryDataZone_class();
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "init": OCS.Advisories.Functions.define_AdvisoryDataZone_class
        };
    }
} catch (e) {

}